import { Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import states from '../../modules/states';
import { toFormattedNumber, toPercent } from '../../modules/text';
import povertyIncome, { getRatesByState } from './data';

function AveragePricePoverty() {
  const { stateCode } = useParams();

  const [, setReady] = useState(false);
  const [error, setError] = useState(null);
  const [price, setPrice] = useState(null);

  useEffect(() => {
    setReady(false);

    // function getRatesByState() {
    //   let whereClause = `state_fips=${stateFIPS[stateCode.toUpperCase()]}`;
    //   whereClause += composeWhereClause({});

    //   return rdsTabulate('ccdc', 'county_setting_group_rate_annual', {
    //     dims: 'state',
    //     measure: 'average_rate:AVG(rate)',
    //     where: whereClause,
    //   }, true);
    // }

    Promise.all([getRatesByState(stateCode)])
      .then((responses) => {
        setPrice(responses[0].parsedBody.dataProvider[0].average_rate);
      })
      .catch((err) => {
        setError(err);
      })
      .finally(() => {
        setReady(true);
      });
  }, [stateCode]);

  return (
    <>
      {error && <Typography variant="body1" color="error">{error.message}</Typography>}
      In <b>{states[stateCode.toUpperCase()]}</b>, families of 3 with 2 adults and 1 child 18 and under,
      earning ${toFormattedNumber(povertyIncome['Family of 3'])} (100% of FPL), spend an average of <b>{toPercent(price / povertyIncome['Family of 3'])}</b> of their household income on child care.
      <br /><br />
      Families of 2 with 1 adult and 1 child 18 and under, earning ${toFormattedNumber(povertyIncome['Family of 2'])} (100% of FPL), spend an average of <b>{toPercent(price / povertyIncome['Family of 2'])}</b> of their household income on child care.
      <br /><br />
      Affordability varies by setting and child age.
    </>
  );
}

export default AveragePricePoverty;
